module.exports = __webpack_public_path__ + "media/images/emoticons/coldsweats01-8bc1c532b659b1c191f5da3de9b3353e.gif";